//UI components
const steps = document.querySelectorAll('.step');
const lines = document.querySelectorAll('.line');
const containers = document.querySelectorAll('.step-container');
const bundleWrapper = document.querySelector('.pdp-bundle-main__wrapper');
const productInfoWrapper = document.querySelector('.product__info-wrapper');
const productTitle = document.querySelector('.product__title');
const productInfoContainer = document.querySelector('.product__info-container');
const mediaWrapper = document.querySelector('.product__media-wrapper');
const toggleButtons = document.querySelectorAll('[build-your-bundle-toggle]');
const titleElements = document.querySelectorAll('.bundle-progress-bar__title .text');
const slider = $('.media_main_preview_slider'); 
const searchInput = document.getElementById("search");
const oils = document.querySelectorAll('.options.oils');
const tabs = document.querySelectorAll('.tab');
const placeholderImg = "https://cdn.shopify.com/s/files/1/0664/2381/6366/files/tabler_leaf.svg?v=1731523590"
const hello = document.getElementById("hello")
//States
let currentStep = 1;
let isEditing = false; 

// Pricing
let discountedPrice = null;
const discountPercentage = parseFloat(bundleWrapper.dataset.discountPercentage || 0);
const discountMultiplier = 100 - discountPercentage; 

// Product data 
const selectedData = {
    diffuserId: null,
    oilSelected: null,
    oilSize: null,
};

// Function - Step 1 - to update the current step
function updateStep(newStep) {
    if (newStep > steps.length || newStep < 1) {
        console.error('Invalid step:', newStep);
        return;
    }

    // Hide all steps and show only the current step
    containers.forEach((container, index) => {
        container.classList.toggle('hidden', index + 1 !== newStep);
    });

    // Update progress bar
     steps.forEach((stepElement, index) => {
        if (index + 1 < newStep) {
            stepElement.classList.add('completed');
            console.log("Step Element Completed:", stepElement);
    
            // Complete the line after this step (if it exists)
            if (lines[index]) {
                lines[index].classList.add('completed');
            }
        } else {
            stepElement.classList.remove('completed');
    
            // Remove completed state from the line after this step
            if (lines[index]) {
                lines[index].classList.remove('completed');
            }
        }
    
        // Toggle active class for the current step
          const isActive = index + 1 === newStep;
          stepElement.classList.toggle('active', isActive);
      
          // Toggle active class for the line after the active step
          if (lines[index]) {
              lines[index].classList.toggle('active', isActive);
          }
    });

  // Update the title elements
    titleElements.forEach((titleElement, index) => {
        if (index + 1 < newStep) {
            titleElement.classList.add('completed');
            titleElement.classList.remove('active');
        } else if (index + 1 === newStep) {
            titleElement.classList.add('active');
            titleElement.classList.remove('completed');
        } else {
            titleElement.classList.remove('completed');
            titleElement.classList.remove('active'); 
        }
    });


    currentStep = newStep;

    // Handle final step render
    const stepText = document.querySelector('.text:last-child');
    const stepWidth = document.querySelector('.bundle-progress-bar__title');
    if (currentStep === 4) {
        renderSummary();
        stepText.innerHTML = `<span>03</span> Complete!`;
        stepWidth.style.width = "100%"
    }else if (currentStep === 3){
       stepText.innerHTML = `<span>03</span> Size`;
       stepWidth.style.width = "99%"
    }
}

// Function - Step 3 - Render oil size variants based on oil selected
function renderSizes(product) {
    const optionsContainer = document.querySelector("#step-3 .options");
    optionsContainer.innerHTML = "";

    // Ensure product and variants exist
    if (!product || !product.variants || product.variants.length === 0) {
        console.error("No product or variants found to render.");
        optionsContainer.innerHTML = "<p>No sizes available for this product.</p>";
        return;
    }

    // Filter and render only available variants
    const availableVariants = product.variants.filter(variant => variant.available);

    if (availableVariants.length === 0) {
        optionsContainer.innerHTML = "<p>No available sizes for this product.</p>";
        return;
    }

    availableVariants.forEach(variant => {
        const originalPrice = parseFloat(variant.price) / 100;
        const optimizedImageSrc = variant.featured_image
            ? `${variant.featured_image.src}?width=200&height=200&crop=center`
            : placeholderImg;

        let discountedPrice = (variant.selling_plan_allocations.length > 0) ? variant.selling_plan_allocations[0].price * .01 : null;

        // Calculate discounted price if discountPercentage is valid
        if (discountPercentage > 0) {
            //discountedPrice = originalPrice * (100 - discountPercentage) / 100;
        }
        console.log(variant,'=========',discountedPrice)
        if (discountedPrice == null){

        }

        const option = document.createElement("div");
        option.classList.add("option", "oil");
        option.innerHTML = `
            <div class="option__image">
              <img src="${optimizedImageSrc}" alt="${variant.title}" loading="eager">
            </div>
            <h4 class="option__title">${variant.title}</h4>
            <div class="oil-info-pricing">
              ${
                discountedPrice !== null
                  ? `<p><span class="oil-info--price-discount">$${discountedPrice.toFixed(2)}</span></p>`
                  : ''
              }
              <p class="oil-info--price">$${originalPrice.toFixed(2)}</p>
            </div>
        `;
        optionsContainer.appendChild(option);

        // Handle size selection
        option.addEventListener("click", () => {
            document.querySelectorAll(".option").forEach(opt => opt.classList.remove("selected"));
            option.classList.add("selected");

            selectedData.oilSize = variant;

            updateStep(4);
            renderSummary();
        });
    });

    if (optionsContainer.innerHTML.trim() === "") {
        optionsContainer.innerHTML = "<p>No available sizes for this product.</p>";
    }
}




// Function - Step 4 - to render the summary dynamically
function renderSummary() {
    const summaryContainer = document.querySelector("#step-4 .summary");
    summaryContainer.innerHTML = "";
console.log(selectedData,'selectedData')
    // Calculate prices for diffuser (no discount)
    let diffuserOriginalPrice = parseFloat(selectedData.diffuserId.price) / 100;
    let diffusercompareAtPrice = parseFloat(selectedData.diffuserId.compare_at_price) / 100;
    let diffuserDiscountedPrice = null; // No discount for diffuser
 
    let diffuserSavePrice =  diffusercompareAtPrice - diffuserOriginalPrice;
    // Calculate prices for oil (10% discount)
    let oilOriginalPrice = parseFloat(selectedData.oilSize.price) / 100;
    let oilDiscountedPrice = oilOriginalPrice * 0.9; // 10% discount

    // Calculate totals
    const totalOriginalPrice = diffuserOriginalPrice + oilOriginalPrice;
    const totalOriginalPriceGrand = oilOriginalPrice + diffusercompareAtPrice;
    const totalDiscountedPrice = diffuserOriginalPrice + oilDiscountedPrice;
    const totalSavings = totalOriginalPrice - totalDiscountedPrice;
    const totalSavingsGrand = totalSavings + diffuserSavePrice;

    // Ensure all selections are made
    if (!selectedData.diffuserId || !selectedData.oilSelected || !selectedData.oilSize) {
        console.error("Incomplete selection data.");
        summaryContainer.innerHTML = "<p>Please complete all steps.</p>";
        return;
    }

    // Render selected diffuser (no discount)
     let discountPercentagen = ((oilOriginalPrice - oilDiscountedPrice) / oilOriginalPrice) * 100;
      let discountPercentagedef = ((diffusercompareAtPrice - diffuserOriginalPrice) / diffusercompareAtPrice) * 100;
     
    const diffuserSummary = `
      <div class="summary-item-wrapper">
        <button class="edit-button" data-step="1">
          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99998 15.6666H16.5M1.5 15.6666H2.89545C3.3031 15.6666 3.50693 15.6666 3.69874 15.6206C3.8688 15.5798 4.03138 15.5124 4.1805 15.421C4.34869 15.318 4.49282 15.1738 4.78107 14.8856L15.25 4.41663C15.9404 3.72628 15.9404 2.60699 15.25 1.91663C14.5597 1.22628 13.4404 1.22628 12.75 1.91663L2.28105 12.3856C1.9928 12.6738 1.84867 12.818 1.7456 12.9862C1.65422 13.1353 1.58688 13.2979 1.54605 13.4679C1.5 13.6597 1.5 13.8636 1.5 14.2712V15.6666Z" stroke="#696969" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="summary-item">
            <img src="${selectedData.diffuserId.image}" alt="Selected Diffuser" class="summary-image">
            <div class="summary-item__content">
                <p class="summary-item-title--variant"><span>${selectedData.diffuserId.productVarTitle}</span></p>
                <h4 class="summary-item-title">${selectedData.diffuserId.title}</h4>
                <p class="summary-item-meta">${selectedData.diffuserId.metafield}</p>
                <div class="summary-price">
                  <p><span class="price">$${diffuserOriginalPrice.toFixed(2)}</span></p>
                  <p class="price-discounted">$${diffusercompareAtPrice.toFixed(2)}</p>
                   <p class="discount__badge">${discountPercentagedef.toFixed(0)}% off</p>
                </div> 
            </div> 
        </div>
      </div>
    `;

    // Render selected oil (with 10% discount)
    let discountPercentage = ((oilOriginalPrice - oilDiscountedPrice) / oilOriginalPrice) * 100;
    const oilSummary = `
      <div class="summary-item-wrapper">
        <button class="edit-button" data-step="2">
          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99998 15.6666H16.5M1.5 15.6666H2.89545C3.3031 15.6666 3.50693 15.6666 3.69874 15.6206C3.8688 15.5798 4.03138 15.5124 4.1805 15.421C4.34869 15.318 4.49282 15.1738 4.78107 14.8856L15.25 4.41663C15.9404 3.72628 15.9404 2.60699 15.25 1.91663C14.5597 1.22628 13.4404 1.22628 12.75 1.91663L2.28105 12.3856C1.9928 12.6738 1.84867 12.818 1.7456 12.9862C1.65422 13.1353 1.58688 13.2979 1.54605 13.4679C1.5 13.6597 1.5 13.8636 1.5 14.2712V15.6666Z" stroke="#696969" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="summary-item">
            <img src="${selectedData.oilSize.featured_image.src}" alt="${selectedData.oilSelected.title}" class="summary-image" loading="lazy">
            <div>
                <p class="summary-item-title--variant"><span>${selectedData.oilSize.title}</span></p>
                <h4 class="summary-item-title">${selectedData.oilSelected.title}</h4>
                <p class="summary-item-meta">${selectedData.oilSelected.metafield_inspo}</p>
                <div class="summary-price ">
                  <p><span class="price">$${oilDiscountedPrice.toFixed(2)}</span></p>
                  <p class="price-discounted">$${oilOriginalPrice.toFixed(2)}</p>
                  <p class="discount__badge">${discountPercentage.toFixed(0)}% off</p>
                </div>
            </div>
        </div>
      </div>
    `;

    summaryContainer.innerHTML = `
      <div class="order-summary">
        <div class="summary-item__final">
            <p class="order-summary-title">DIFFUSER</p>
            ${diffuserSummary}
        </div>
        <div class="summary-item__final">
            <p class="order-summary-title">FRAGRANCE OIL</p>
            ${oilSummary}
        </div>
      </div>
      <p class="order-summary-title">SUMMARY</p>
      <div class="summary-footer">
          <div class="summary-footer__info">
              <p class="savings-info">You saved <span class="savings money">$${totalSavingsGrand.toFixed(2)}</span></p>
              <p class="total-info">
                <span class="total-title">Total</span>
                <span class="total-price money">$${totalDiscountedPrice.toFixed(2)}</span>
                <span class="price-discounted total-orignal-price">$${totalOriginalPriceGrand.toFixed(2)}</span>
              </p>
          </div>
          <button class="bundle-add-to-cart">
          <span class="atcm">
              Add to Cart
             
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.334 7.50002V5.00002C13.334 3.15907 11.8416 1.66669 10.0006 1.66669C8.15968 1.66669 6.6673 3.15907 6.6673 5.00002V7.50002M2.99397 8.62666L2.49397 13.96C2.35181 15.4764 2.28072 16.2346 2.53234 16.8202C2.75338 17.3347 3.14073 17.7601 3.63232 18.0282C4.19191 18.3334 4.95344 18.3334 6.47651 18.3334H13.5248C15.0478 18.3334 15.8094 18.3334 16.369 18.0282C16.8605 17.7601 17.2479 17.3347 17.4689 16.8202C17.7205 16.2346 17.6495 15.4764 17.5073 13.96L17.0073 8.62666C16.8872 7.34614 16.8272 6.70588 16.5392 6.22182C16.2856 5.79551 15.9109 5.45428 15.4628 5.24156C14.954 5.00002 14.3109 5.00002 13.0248 5.00002L6.97651 5.00002C5.69038 5.00002 5.04731 5.00002 4.53848 5.24156C4.09035 5.45428 3.71564 5.79551 3.46202 6.22182C3.17404 6.70588 3.11402 7.34614 2.99397 8.62666Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
               </span>
              <div class="loading__spinner">
  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

</div>
          </button>
      </div>
    `;

    // Event Listener for "Edit" buttons
    document.querySelectorAll(".edit-button").forEach(button => {
        button.addEventListener("click", (e) => {
            const editButton = e.target.closest(".edit-button");
            if (!editButton) return;
            const stepToEdit = parseInt(editButton.dataset.step, 10);
            if (stepToEdit === 1) {
                isEditing = true;
            } else {
                isEditing = false;
            }
            updateStep(stepToEdit);
        });
    });

    // Add event listener to Add to Cart button
  document.querySelector(".bundle-add-to-cart").addEventListener("click", function(e) {
  handleAddToCart(e);
});
}

// Function to toggle visibility of bundle
function toggleBundle(notdragged) {

    if (!bundleWrapper || !productTitle) {
        console.error('Bundle wrapper or product title not found.');
        return;
    }

    if (!bundleWrapper.classList.contains('hidden')) {
        bundleWrapper.classList.add('hidden');
        bundleWrapper.style.display = 'none';

        // Reset styles when the pop-up is closed
        mediaWrapper.style.maxWidth = '';
        productInfoWrapper.style.maxWidth = '';
        productInfoWrapper.style.width = '';
        productInfoContainer.style.maxWidth = '';

        // Reslick the slider
        if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
        }
        slider.slick({arrows: false});
      
        // Restore all siblings of product__info-container
        Array.from(productInfoContainer.children).forEach(sibling => {
            sibling.style.display = ''; 
        });
    } else {
        productTitle.insertAdjacentElement('afterend', bundleWrapper);

        if (window.innerWidth > 1024) { 
              mediaWrapper.style.maxWidth = '40%';
              productInfoWrapper.style.maxWidth = '55%';
              productInfoWrapper.style.width = '100%';
              productInfoContainer.style.maxWidth = '100%';
              
              // Reslick the slider
              if (slider.hasClass('slick-initialized')) {
                  slider.slick('unslick');
              }
              slider.slick({arrows: false});
          }
      
        
          // Remove all siblings of product__info-container
          Array.from(productInfoContainer.children).forEach(sibling => {
              if (sibling !== productInfoContainer && sibling !== bundleWrapper && sibling !== productTitle) {
                  sibling.style.display = 'none';
              }
          });
  
          bundleWrapper.classList.remove('hidden');
          bundleWrapper.style.display = 'block';
  
          // Scroll up to pop-up 
         if (notdragged){

         }
         else{

   
          const rect = productInfoContainer.getBoundingClientRect() ;
         if (window.innerWidth <= 768) { 
              window.scrollTo({
                  top: window.scrollY + rect.top + 20,
                  behavior: 'smooth'
              });
         } else {
              window.scrollTo({
                  top: window.scrollY + rect.top + -200,
                  behavior: 'smooth'
              });
          }
                }
       window.addEventListener('resize', handleResize);
      }
}

//Function to Add to Cart
function handleAddToCart(e) {
   
    var currentbtn= e.currentTarget;
    if (currentbtn){
   currentbtn.classList.add("loadermain");
   
    }
    const diffuserId = parseInt(selectedData.diffuserId?.id, 10);
    const oilVariantId = parseInt(selectedData.oilSize?.id);
    const oilSellingPlan = parseInt(selectedData.oilSize?.selling_plan_allocations[0].selling_plan_id) || null;
    
    if (!diffuserId || !oilVariantId) {
        alert('Please select both a diffuser and an oil before adding to the cart.');
        return;
    }

    // Generate a unique bundle ID using timestamp
    const uniqueBundleId = `bundle-${Date.now()}`;

    // Add items to the cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: [
                { 
                    id: oilVariantId, 
                    quantity: 1, 
                    selling_plan: oilSellingPlan,
                    properties: {
                        '_bundle_id': uniqueBundleId
                    }
                },
                { 
                    id: diffuserId, 
                    quantity: 1,
                    properties: {
                        '_bundle_id': uniqueBundleId
                    }
                },
            ],
        }),
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error('Failed to add items to the cart.');
        }
        return response.json();
    })
    .then(($data) => {
        console.log('Items added to cart successfully.');
        if (currentbtn){
        currentbtn.classList.remove("loadermain");
        }
        const $cartBtn = document.querySelectorAll('.header__icons a[href*="/cart"]');
        if($cartBtn.length > 0){
            document.querySelector('cart-drawer').classList.remove('is-empty');
            let url = window.location.href + '?section_id=cart-drawer';
            let $qty = 0;
            $data.items.forEach(($item)=>{
                $qty = $qty + $item.quantity;
            });
            $cartBtn[0].click();

            if($cartBtn[0].querySelectorAll('.cart-count-bubble').length > 0){
                $cartBtn[0].querySelector('.cart-count-bubble').innerHTML = `<span aria-hidden="true">${$qty}</span><span class="visually-hidden">${$qty} items</span>`;
            }
            else{
                const $bubble = document.createElement('div');
                $bubble.classList.add('cart-count-bubble');
                $bubble.innerHTML = `<span aria-hidden="true">${$qty}</span><span class="visually-hidden">${$qty} items</span>`; 
                $cartBtn[0].appendChild($bubble);
            }
      
            fetch(url)
              .then((response) => response.text())
              .then((html) => {
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
      
                let updatedCartDrawerContent = tempDiv.querySelector('cart-drawer');
      
                if (updatedCartDrawerContent) {
                  let cartDrawer = document.querySelector('cart-drawer');
                  cartDrawer.innerHTML = updatedCartDrawerContent.innerHTML;
                   
                } else {
                  console.error("Error: 'cart-drawer' element not found in the fetched HTML.");
                }
              })
              .catch((error) => console.error('Error updating cart drawer:', error));
        }
        else{
            // Redirect to the cart page
            window.location.href = '/cart';
        }
    })
    .catch((error) => {
        console.error('Error adding items to cart:', error);
    });
}

// Initialize Step 1
updateStep(1);

// handle pop-up resize events
function handleResize() {
    if (!bundleWrapper || bundleWrapper.classList.contains('hidden')) return;

    if (window.innerWidth > 1024) {
        mediaWrapper.style.maxWidth = '40%';
        productInfoWrapper.style.maxWidth = '55%';
        productInfoWrapper.style.width = '100%';
        productInfoContainer.style.maxWidth = '100%';
    } else {
        // Adjust styles for mobile
        mediaWrapper.style.maxWidth = '';
        productInfoWrapper.style.maxWidth = '';
        productInfoWrapper.style.width = '';
        productInfoContainer.style.maxWidth = '';
    }
}
document.addEventListener('DOMContentLoaded', () => {

    // Toggle open/close of pop-up 
   var notd = false;

toggleButtons.forEach(button => {
    button.addEventListener('click', () => toggleBundle(notd));
});

    // Step 1 - Store diffuser product and move to Step 2
    document.querySelectorAll(".option-diffuser").forEach(option => {
        option.addEventListener("click", () => {
          console.log(option.dataset,'option')
            const productId = option.dataset.productId;
            const productImage = option.querySelector("img")?.src || placeholderImg;
            const productTitle = option.dataset.productName || "Diffuser";
            const productPrice =  option.dataset.productPrice;
            const productCompare_at_price =  option.dataset.productCompare_at_price;
            const productVarTitle =  option.querySelector(".option__title")?.textContent.trim() || "Variant";
            const productMeta =  option.dataset.productMeta;
  
           selectedData.diffuserId = {
                id: productId,
                image: productImage,
                title: productTitle,
                productVarTitle: productVarTitle,
                price: productPrice,
                compare_at_price: productCompare_at_price,
                metafield:productMeta,
            };
  
            // Highlight the selected option
            document.querySelectorAll(".option-diffuser").forEach(opt => opt.classList.remove("selected"));
            option.classList.add("selected");
  
            if (isEditing) {
                isEditing = false;
                updateStep(4);
            } else {
                updateStep(2); 
            }
        });
    });

    // Step 2 - Store oil product and move to Step 3
    document.querySelectorAll(".oil").forEach(oil => {
        oil.addEventListener("click", () => {
            const productId = oil.dataset.productId;
            const variantIds = JSON.parse(oil.dataset.variantIds || "[]");
            const productTitle = oil.querySelector("h4").textContent;
            const productMetaHotel = oil.dataset.inspiredByHotel;
            const productMetaNotes = oil.dataset.inspiredByNotes;
  
            // Store selected product data
            selectedData.oilSelected = {
                id: productId,
                title: productTitle,
                variants: variantIds,
                metafield_inspo:productMetaHotel,
                metafield_notes:productMetaNotes,
            };
  
            // Move to Step 3
            updateStep(3);
            renderSizes(selectedData.oilSelected);
        });
    });

    // Step 2-3 - Add Back Button Functionality
    document.querySelectorAll(".step-container").forEach((container, index) => {
        if (index > 0) { // Only for steps 2 and beyond
            const backButton = document.createElement("button");
            backButton.innerHTML = `
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;
            backButton.classList.add("back-button");
            backButton.addEventListener("click", () => {
                updateStep(currentStep - 1);
            });
    
            // Insert the back button next to the h3 in each step container
            const heading = container.querySelector("h3");
            if (heading) {
                heading.insertAdjacentElement("beforebegin", backButton);
            }
        }
    });

    // Search Functionality 
    const searchContainer = document.querySelector('.search-container');
    const searchIcon = searchContainer.querySelector('.input-icon');
    const searchInput = document.getElementById('search');
    const oilsContainers = document.querySelectorAll('.options.oils');

    // Filter oils based on the search term
    function filterOils(searchTerm) {
      const activeContainer = document.querySelector('.options.oils:not(.hidden)');
    
      if (activeContainer) {
        const oils = activeContainer.querySelectorAll('.oil');
        let found = false;
    
        oils.forEach((oil) => {
          const title = oil.querySelector('h4').textContent.toLowerCase();
          const description = oil.querySelector('p')?.textContent.toLowerCase() || '';
    
          if (title.includes(searchTerm) || description.includes(searchTerm)) {
            oil.style.display = '';
            found = true;
          } else {
            oil.style.display = 'none';
          }
        });
    
        handleNoResultsMessage(activeContainer, found);
      }
    }
    
    // Function to handle "No Results" message
    function handleNoResultsMessage(container, found) {
      const noResultsMessage = container.querySelector('.no-results');
      if (!found) {
        if (!noResultsMessage) {
          const noResults = document.createElement('p');
          noResults.textContent = 'No matching oils found.';
          noResults.className = 'no-results';
          container.appendChild(noResults);
        }
      } else {
        noResultsMessage?.remove();
      }
    }
    
    // Initialize search functionality
    searchInput.addEventListener('input', (event) => {
      const searchTerm = event.target.value.toLowerCase();
      filterOils(searchTerm);
    });
    
    // Handle search bar animation for mobile
    if (window.innerWidth <= 767) {
      searchContainer.addEventListener('click', function () {
        if (!searchContainer.classList.contains('expanded')) {
          searchContainer.classList.add('expanded');
          searchInput.focus();
        }
      });
    
      document.addEventListener('click', function (event) {
        if (!searchContainer.contains(event.target) && searchContainer.classList.contains('expanded')) {
          searchContainer.classList.remove('expanded');
          searchInput.blur();
        }
      });
    }
    
    // Default visibility for oils (set the first one visible by default)
    function initializeOilsVisibility() {
      oilsContainers.forEach((container, index) => {
        if (index === 0) {
          container.classList.remove('hidden');
        } else {
          container.classList.add('hidden');
        }
      });
    }
    
    // Call the initialization function
    initializeOilsVisibility();

    // Click event listeners fot tabbing between oil collections
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetCollection = tab.dataset.collection;
    
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
    
        oils.forEach(oil => {
          if (oil.dataset.collection === targetCollection) {
            oil.classList.remove('hidden');
          } else {
            oil.classList.add('hidden');
          }
        });
      });
    });

   // Reset bundle display styles when window is resized below desktop 
  window.addEventListener('resize', function() {
      if (window.innerWidth < 1024) { 
        mediaWrapper.style.maxWidth = '';
        productInfoWrapper.style.maxWidth = '';
        productInfoWrapper.style.width = '';
        productInfoContainer.style.maxWidth = '';
      }
   });

});